import { render } from "./CreateUsername.vue?vue&type=template&id=4ebd3468&scoped=true"
import script from "./CreateUsername.vue?vue&type=script&lang=js"
export * from "./CreateUsername.vue?vue&type=script&lang=js"

import "./CreateUsername.vue?vue&type=style&index=0&id=4ebd3468&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebd3468"]])

export default __exports__